<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-form>
        <v-layout column>
          <v-flex>
            <v-text-field label="分类名称*" v-model="form.name" prepend-icon="$vuetify.icons.title" :readonly="disabledFlag"></v-text-field>
          </v-flex>
          <v-flex>
            <v-textarea label="分类描述*" rows="1" auto-grow v-model="form.description" prepend-icon="$vuetify.icons.comment" :readonly="disabledFlag">
            </v-textarea>
          </v-flex>
          <v-flex>
            <v-autocomplete
              :readonly="disabledFlag"
              :items="form.orgSelect"
              v-model="form.org"
              v-on:keyup="getOrgs"
              prepend-icon="$vuetify.icons.org"
              label="所属分组"
              clearable
              hide-details
              hide-selected
              item-text="name"
              item-value="id"
              :rule="[$rules.requiredS('必填')]"
            >
              <template slot="no-data">
                <v-alert :value="true" color="error">
                  暂无该分组信息
                </v-alert>
              </template>
              <template slot="item" slot-scope="props">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-flex row align-center justify-between>
                      <span>{{props.item.name}}</span>
                    </v-flex>
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <!--<span class="grey&#45;&#45;text caption text-xs-right">{{props.item.loginId}}</span>-->
                </v-list-tile-action>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-layout justify-center>
            <v-btn class="primary" @click="submit" :loading="loading" :disabled="disabledFlag">提交</v-btn>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card>
  </l-layout>
</template>
<script>
export default{
  name: 'ruleGroupForm',
  data () {
    return {
      loading: false,
      disabledFlag: false,
      form: {
        name: '',
        description: '',
        org: '',
        orgSelect: []
      }
    }
  },
  methods: {
    getUserInfo () {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getOrgs (data) {
      let search = (data === undefined) ? '' : data.target.value
      let res = await this.$store.dispatch('charging/getOrgs', {name: search, id: ''})
      if (res.data.status === 1) {
        this.form.orgSelect = res.data.data.content
      }
      else {
        this.form.orgSelect = []
      }
    },
    async submit () {
      let params = {
        name: this.form.name,
        description: this.form.description,
        obgrpId: this.form.org,
        creator: this.getUserInfo().name
      }
      this.loading = true
      let res = await this.$store.dispatch('charging/addRuleGroup', params)
      this.loading = false
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '添加成功'})
        this.disabledFlag = true
      }
      else {
        this.$L.alert('error', {message: '添加失败，原因：' + res.data.msg})
      }
    }
  }
}
</script>
